import React from 'react';

function FriendFilterDropdown({ users, currentUserId, value, onChange, id }) {
  const others = (users || []).filter(u => u.id !== currentUserId);
  if (others.length === 0) return null;
  return (
    <select id={id} className="friend-filter-select" value={value || ''} onChange={(e) => onChange(e.target.value)}>
      <option value="">Show all</option>
      {others.map(u => (
        <option key={u.id} value={u.id}>With {u.name}</option>
      ))}
    </select>
  );
}

export default FriendFilterDropdown;
